
    import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
    import ListBase from '@/lib/listbase';
    import Util from '@/lib/util';
    import VWidget from '@/components/VWidget.vue';

    @Component({
        components: { VWidget },
    })

export default class TablesStats extends ListBase {
    
    get columns() {
        let cols = [{ value: 'name', text: '', type: 'text', sortable: false, align: 'start', width: '210px', class: '' }];

        this.months.forEach(m => {
            cols.push({ value: m.field, text: m.name, type: 'text', width: '82px', sortable: false, align: 'center', class: '' });
        });
        cols.push({ value: 'total', text: 'TOTAL', type: 'text', width: '65px', sortable: false, align: 'center', class: '' });
        return cols;
    }

    get months() {
        let list = this.gCommonList('months');
        list.forEach(m => {
            m['field'] = 'month_' + m.id;
        });
        return list;
    }

    get listCober() {
        return this.$store.state.quiz.cobertura;
    }

    get listPost() {
        return this.$store.state.quiz.postventa;
    }

    get loading() {
        return this.$store.state.quiz.loading;
    }
    
        loadData() {
            this.$emit('load-data');
        }

    mounted() { 
    }
 }
